import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const PrivateRoute = ({ children, role = "employee" }) => {
	const employeeToken = Cookies.get("employeeToken");
	const consultantToken = Cookies.get("ConsultantToken");

	if (role === "employee" && !employeeToken) {
		return <Navigate to="/" replace />;
	}

	if (role === "consultant" && !consultantToken) {
		return <Navigate to="/Consultant-Login" replace />;
	}

	return children;
};

export default PrivateRoute;
